module.exports = __webpack_public_path__ + "static/media/isLiked.3ef8a1df.svg";